import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { ArrowRight, Mail, Lock, Sparkles } from "lucide-react";

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    // Mock auth — any input works
    setTimeout(() => {
      try { localStorage.setItem("rd_authed", "1"); } catch (_) {}
      navigate("/dashboard");
    }, 450);
  };

  return (
    <div className="rd-grain min-h-screen flex flex-col lg:flex-row" data-testid="login-page">
      {/* LEFT — visual */}
      <div
        className="relative lg:w-1/2 min-h-[520px] lg:min-h-screen flex items-end pt-28 pb-10 px-6 lg:p-12 overflow-hidden"
        style={{
          backgroundImage:
            "linear-gradient(135deg, rgba(10,10,10,0.55) 0%, rgba(10,10,10,0.92) 100%), url('https://images.unsplash.com/photo-1629881635342-c1272d45d0fa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxzZW1pJTIwdHJ1Y2slMjBuaWdodHxlbnwwfHx8fDE3ODA2ODA3Nzd8MA&ixlib=rb-4.1.0&q=85')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Floating sticker label top-left */}
        <div className="absolute top-6 left-6 lg:top-12 lg:left-12 z-10">
          <Logo size="lg" />
        </div>

        <div className="absolute top-20 left-6 lg:top-12 lg:right-12 lg:left-auto z-10">
          <span className="rd-sticker bg-[#F9DB81] text-black border-black"
            style={{ boxShadow: "3px 3px 0 0 #0A0A0A" }}
            data-testid="mock-preview-badge">
            <Sparkles size={12} strokeWidth={3} /> Mock Preview
          </span>
        </div>

        <div className="relative z-10 max-w-md rd-fade-up mt-16 lg:mt-0">
          <div className="rd-sticker mb-5 bg-black/60 backdrop-blur-sm">
            ◆ For Freight Brokers Only
          </div>
          <h1 className="font-display font-black text-[2.25rem] sm:text-5xl lg:text-6xl leading-[1.05] lg:leading-[0.95] tracking-tight text-white">
            Book loads.<br/>
            Issue rate cons.<br/>
            <span className="text-[#F9DB81]">Get paid.</span>
          </h1>
          <p className="mt-5 text-zinc-300 text-sm lg:text-base max-w-sm">
            The brokerage cockpit that replaces clunky legacy TMS — manage every booked load and dispatch carrier confirmations in seconds.
          </p>
        </div>
      </div>

      {/* RIGHT — form */}
      <div className="lg:w-1/2 flex items-center justify-center p-8 lg:p-12 relative">
        <form
          onSubmit={handleSubmit}
          className="w-full max-w-md rd-card p-8 lg:p-10 rd-fade-up"
          data-testid="login-form"
        >
          <div className="mb-8">
            <div className="rd-section-tag mb-4">◆ Sign In</div>
            <h2 className="font-display font-black text-3xl lg:text-4xl tracking-tight">
              Welcome back, broker.
            </h2>
            <p className="text-zinc-400 mt-2 text-sm">
              Enter any credentials to launch the mock preview.
            </p>
          </div>

          <div className="space-y-5">
            <div>
              <label className="rd-label" htmlFor="email">Email Address</label>
              <div className="relative">
                <Mail size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-zinc-500 pointer-events-none z-10" />
                <input
                  id="email"
                  type="email"
                  className="rd-input"
                  style={{ paddingLeft: "44px" }}
                  placeholder="broker@rocketsdispatch.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-testid="login-email-input"
                />
              </div>
            </div>

            <div>
              <label className="rd-label" htmlFor="password">Password</label>
              <div className="relative">
                <Lock size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-zinc-500 pointer-events-none z-10" />
                <input
                  id="password"
                  type="password"
                  className="rd-input"
                  style={{ paddingLeft: "44px" }}
                  placeholder="••••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  data-testid="login-password-input"
                />
              </div>
            </div>

            <div className="flex items-center justify-between text-xs text-zinc-500 pt-1">
              <label className="flex items-center gap-2 cursor-pointer">
                <input type="checkbox" className="accent-[#F9DB81] h-3.5 w-3.5" defaultChecked />
                Keep me signed in
              </label>
              <a className="hover:text-[#F9DB81] transition-colors" href="#">Forgot password?</a>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="rd-btn-primary w-full py-3.5 mt-2 flex items-center justify-center gap-2 text-sm disabled:opacity-70"
              data-testid="login-submit-button"
            >
              {loading ? "Signing in..." : "Sign In"}
              {!loading && <ArrowRight size={16} strokeWidth={3} />}
            </button>
          </div>

          <div className="mt-8 pt-6 border-t border-white/10 flex items-center justify-between text-xs">
            <span className="text-zinc-500">No account?</span>
            <a href="#" className="text-[#F9DB81] font-semibold uppercase tracking-wider">
              Request access →
            </a>
          </div>
        </form>
      </div>
    </div>
  );
}
